module.exports = __webpack_public_path__ + "e0106718/img/send-icon.3cfb6275.svg";